<template>
  <ul class="topic-list">
    <li v-for="(topic, index) in topics" v-if="topic" :key="index">
      <router-link :to="'/track/'+topic.id">
        <h2>{{topic.topic}}</h2>
      </router-link>
      <div v-html="topic.introduce"></div>
      <div v-if="topic.lectureIds.length">
        <h2 class="title">旗下议题</h2>
        <ul class="l-titles">
          <li v-for="(lid, idx) in topic.lectureIds" :key="idx" v-if="lectures[lid]">
            {{(idx + 1) + '. ' + lectures[lid].title}}
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
// import Topic from './topic'

export default {
  components: {
  },
  props: [
    'topics',
    'lectures'
  ],
  data () {
    return {
      curTab: 0
    }
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>

  .title
    font-size: 16px
    color: #000
    padding-bottom: 6px
    border-bottom: 1px solid #d6dce3
  .l-titles
    margin-top: 12px

  .topic-list
    display: flex
    width: 100%
    flex-wrap: wrap
    >li
      width: 363px
      height: auto
      padding: 30px 18px 18px
      margin-right: 25px
      margin-bottom: 25px
      border: 1px solid #d6dce3
      overflow: hidden
      &:nth-child(3n)
        margin-right: 0

      &:hover
        box-shadow: 0 0 5px rgba(213, 225, 238, 1)

      >a
        color: #3e3a39
        display: block
        h2
          font-size: 20px
          color: var(--primary-color)
          padding-bottom: 12px
          border-bottom: 1px solid #d6dce3

      >div
        margin-top: 12px
        text-align: justify
        font-size: 14px
        line-height: 26px
        color: #3e3a39
        text-align: justify
        // display: -webkit-box
        -webkit-box-orient: vertical
        -webkit-line-clamp: 4
        overflow: hidden
        p
          height: 104px
          font-size: 14px
          line-height: 26px
          color: #3e3a39
          display: -webkit-box
          -webkit-box-orient: vertical
          -webkit-line-clamp: 4
          overflow: hidden
</style>
